import { render, staticRenderFns } from "./IndividualTopupsPaymentComponent.vue?vue&type=template&id=30bbcdb3&"
import script from "./IndividualTopupsPaymentComponent.vue?vue&type=script&lang=js&"
export * from "./IndividualTopupsPaymentComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports